import { TypeCodes } from 'constants.js';

// DEV-4540 : les réclamations de type Cession ou Interne ne sont pas soumises à la quantité
// retournable, quelle que soit la qualification (ni affichage des colonnes, ni contrôle de saisie).
export const reclamationSoumiseQuantiteRetournable = (reclamation) =>
    reclamation?.type?.code !== TypeCodes.Cession && reclamation?.type?.code !== TypeCodes.Interne;
